export default __webpack_public_path__ + "static/media/medal 1.cede33bd.svg";